import { NgModule, Optional, SkipSelf } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuard, NoAuthGuard } from '@core/guards';
import { NgxSpinnerModule } from 'ngx-spinner';

import { throwIfAlreadyLoaded } from './guards/module-import.guard';
import {
    ApplicationHeaderInterceptor,
    AuthTokenHeaderInterceptor,
    ApiDefaultHeaderInterceptor,
    ErrorLogInterceptor
} from './interceptors';
import { ExternalApiInterceptor } from './interceptors/external-api.interceptor';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { ErrorPopupInterceptor } from './interceptors/error-popup.interceptor';

const interceptors = [
    {
        provide: HTTP_INTERCEPTORS,
        useClass: ApiDefaultHeaderInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: ApplicationHeaderInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthTokenHeaderInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: ErrorLogInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: ExternalApiInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: ErrorPopupInterceptor, // must be the last one
        multi: true
    }
];

@NgModule({
    imports: [HttpClientModule, NgxSpinnerModule],
    providers: [
        AuthGuard,
        AuthTokenHeaderInterceptor,
        NoAuthGuard,
        ...interceptors,
        {
            provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
            useValue: { useUtc: true }
        },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        }
    ]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}
